import React from 'react';
import { addDays, isAfter, isBefore, isEqual } from 'date-fns';
import { Link } from "@remix-run/react";
import { styled } from 'styled-components';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Shadows } from '../../../../../play-core/styles/Shadows';
import { utcToCentralEuropean } from '../../../../../play-core/utils/date-helper';
import { usePath } from '../../../config/VideoAppContext';
import { startOfTvDay } from '../tv-guide-types';
import { ListProgramEntry } from './ListProgramEntry';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ListEntry = ({
  programGuide: program,
  date,
  time,
  activeChannelId,
  onSelectProgram
}) => {
  const {
    now,
    next
  } = getNowAndNext(program, date, time);
  const {
    tvGuideByChannelPath
  } = usePath();
  return /*#__PURE__*/_jsxs(Layout, {
    children: [/*#__PURE__*/_jsx(LogoContainer, {
      to: tvGuideByChannelPath(date, program.channel),
      children: /*#__PURE__*/_jsx(Logo, {
        alt: program.channel.title,
        src: program.channel.imageUrlRaw ?? program.channel.imageUrl
      })
    }), /*#__PURE__*/_jsxs(NowAndNextLayout, {
      children: [now && /*#__PURE__*/_jsx(ListProgramEntry, {
        channel: program.channel,
        program: now,
        onSelectProgram: onSelectProgram,
        activeChannelId: activeChannelId
      }), next && /*#__PURE__*/_jsx(SeparatorLine, {}), next && /*#__PURE__*/_jsx(ListProgramEntry, {
        channel: program.channel,
        program: next,
        onSelectProgram: onSelectProgram,
        activeChannelId: activeChannelId
      })]
    })]
  });
};
export const Layout = styled.div.withConfig({
  displayName: "ListEntry__Layout",
  componentId: "sc-1nm2gap-0"
})(["display:flex;background-color:", ";height:100%;height:130px;overflow-x:hidden;", ""], Colors.GREY_2a2a2a, Shadows.applySingle(8));
export const NowAndNextLayout = styled.div.withConfig({
  displayName: "ListEntry__NowAndNextLayout",
  componentId: "sc-1nm2gap-1"
})(["height:100%;width:100%;display:flex;flex-direction:column;justify-content:space-evenly;overflow-x:hidden;"]);
const SeparatorLine = styled.div.withConfig({
  displayName: "ListEntry__SeparatorLine",
  componentId: "sc-1nm2gap-2"
})(["height:1px;width:100%;background-color:", ";"], Colors.GREY_454545);
export const LogoContainer = styled(Link).withConfig({
  displayName: "ListEntry__LogoContainer",
  componentId: "sc-1nm2gap-3"
})(["min-width:75px;display:flex;justify-content:center;align-items:center;&:focus-visible{outline-offset:0;}"]);
const Logo = styled.img.withConfig({
  displayName: "ListEntry__Logo",
  componentId: "sc-1nm2gap-4"
})(["width:50px;max-height:30px;object-fit:contain;"]);
const getNowAndNext = (program, date, time) => {
  let now = new Date(`${date}T${time}:00`);
  if (isBefore(now, startOfTvDay(date))) {
    now = addDays(now, 1);
  }
  const index = program.programList.findIndex(entry => {
    const start = utcToCentralEuropean(new Date(entry.startTime));
    const end = utcToCentralEuropean(new Date(entry.endTime));
    return isAfter(now, start) && isBefore(now, end) || isEqual(now, start) || isEqual(now, end);
  });
  if (index > -1) {
    return {
      now: program.programList[index],
      next: program.programList[index + 1]
    };
  }
  return {
    now: undefined,
    next: undefined
  };
};